import axios from 'axios'
import NProgress from 'nprogress'
import store from '@/store'

export const API_URL = 'https://edmentalhealthdev.acem.org.au'
export const DOC_URL = 'https://edmentalhealthcdn.acem.org.au/'

export const Axios = axios.create({
    baseURL: API_URL,
})

export const setAxiosHeaders = (token) => {
    Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// before a request is made start the nprogress
Axios.interceptors.request.use(config => {
    NProgress.start()
    NProgress.inc()
    return config
})

// before a response is returned stop nprogress
Axios.interceptors.response.use(
    response => {
        NProgress.done()
        return response
    },
    error => {
        NProgress.done()

        if (error && error.response && error.response.status === 401) {
            store.dispatch('Auth/logoutUser')
        }

        return error
    })
